"use client"

import { useEffect } from "react"
import { usePathname } from "next/navigation"

function scrollToHashFromLocation(): void {
  const raw = window.location.hash.replace(/^#/, "")
  if (!raw) return
  let id: string
  try {
    id = decodeURIComponent(raw)
  } catch {
    id = raw
  }
  const el = document.getElementById(id)
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" })
  }
}

export function ScrollToTop() {
  const pathname = usePathname()

  useEffect(() => {
    if (typeof window === "undefined") return

    const hash = window.location.hash
    if (hash && hash.length > 1) {
      // Let the target section mount (Suspense / client components), then scroll.
      const t1 = window.setTimeout(() => scrollToHashFromLocation(), 0)
      const t2 = window.setTimeout(() => scrollToHashFromLocation(), 120)
      const t3 = window.setTimeout(() => scrollToHashFromLocation(), 400)
      return () => {
        window.clearTimeout(t1)
        window.clearTimeout(t2)
        window.clearTimeout(t3)
      }
    }

    window.scrollTo(0, 0)
  }, [pathname])

  useEffect(() => {
    if (typeof window === "undefined") return
    const onHashChange = () => scrollToHashFromLocation()
    window.addEventListener("hashchange", onHashChange)
    return () => window.removeEventListener("hashchange", onHashChange)
  }, [])

  return null
}

